class ExpandableList {
    constructor(id) {
        this.id = id;
        this.list = document.getElementById(id);
        this.header = this.list.previousElementSibling;
        this.header.addEventListener('click', this.toggleList.bind(this));
    }

    toggleList() {
        this.list.classList.toggle("active");
    }
}
export default ExpandableList
